import { IonIcon, IonItem, IonLabel, IonSpinner } from '@ionic/react';
import { warningOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../store/hooks';
import { Wrapper } from './Warning.styles';

export interface IComponentProps {}

const Warning: React.FC<IComponentProps> = function () {
  const [items, setItems] = useState(0);
  const { clockingQueue, techCommentQueue, vehicleAttachmentQueue } = useAppSelector((state) => state.requestQueue);

  useEffect(() => {
    setItems((clockingQueue?.length || 0) + (techCommentQueue?.length || 0) + (vehicleAttachmentQueue?.length || 0));
  }, [clockingQueue?.length, techCommentQueue?.length, vehicleAttachmentQueue?.length]);

  return (
    <Wrapper className="offline-sync">
      <IonItem color="warning" lines="none" className="offline-warning">
        <IonIcon icon={warningOutline} slot="start" />
        <IonLabel>
          <IonLabel>DEVICE IS OFFLINE</IonLabel>
        </IonLabel>
        <IonSpinner name="dots" color="secondary" slot="end" />
      </IonItem>

      <IonItem color="tertiary" lines="none" className="sync-warning">
        <IonIcon icon={warningOutline} slot="start" />
        <IonLabel>
          <IonLabel>
            DATA SYNC - PLEASE WAIT ({items} item{items >= 2 ? 's' : ''})
          </IonLabel>
        </IonLabel>
        <IonSpinner name="dots" color="secondary" slot="end" />
      </IonItem>
    </Wrapper>
  );
};

export default Warning;
